import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import { LocationContract } from '@packages/contracts';

import { DISTRICT_QUERY_KEY } from '../query-keys';

type DistrictListRoute = typeof LocationContract['district']['list'];
type DistrictListResponse = ClientInferResponseBody<DistrictListRoute, 200>['result']['districts'];

export type DistrictListQueryOptions = UseQueryOptions<
	DistrictListRoute,
	ClientArgs,
	DistrictListResponse
>;

export const createDistrictListQueryOptions = (provinceId?: string): DistrictListQueryOptions => ({
	queryData: { query: { provinceId } },
	queryKey:  DISTRICT_QUERY_KEY.list(provinceId ?? 'all'),

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.districts,
});
